export const LeadStatus = {
  qualificar: { status: 'qualificar', desc: 'A qualificar' },
  desqualificado: { status: 'desqualificado', desc: 'Desqualificado' },
  qualificado: { status: 'qualificado', desc: 'Qualificado' },
  expirado: { status: 'expirado', desc: 'Expirado' },
  com_agendamento: { status: 'com_agendamento', desc: 'Com agendamento' },
  em_negociacao: { status: 'em_negociacao', desc: 'Em negociação' },
  cliente_aguardando_pagamento: { status: 'cliente_aguardando_pagamento', desc: 'Cliente Aguardando Pagamento' },
  cliente: { status: 'cliente', desc: 'Cliente' },
  negociacao_realizada: { status: 'negociacao_realizada', desc: 'Negociação abandonada' },
  qualificado_agendamento: { status: 'qualificado_com_agendamento', desc: 'Qualificado com agendamento' }
}

export const Usuario = {
  ativo: { id: 'ativo', desc: 'Ativo' },
  bloqueado: { id: 'bloqueado', desc: 'Bloqueado' },
  inativo: { id: 'inativo', desc: 'Inativo' },
  ferias: { id: 'ferias', desc: 'Férias/Licença' },
  contidos_hierarquia: { id: 'contidos_hierarquia', desc: 'Contidos na hierarquia' },
  fora_hierarquia: { id: 'fora_hierarquia', desc: 'Fora da hierarquia' }
}

export const Errors = {
  no_situation_lead: 'Não há leads dessa situação para serem remanejados'
}
